import React, { Component } from "react";
import { Table, Icon, Button, Tooltip } from "antd";
import moment from "moment";
import "antd/dist/antd.css";
import "./style.scss";
import HeaderBar from "./components/header-bar/index";
import {getUploadTypeName} from "../../../consts/uploadtypes";

const { Column } = Table;

const DEFAULT_PAGE_SIZE = 20;
const PAGE_SIZE_OPTIONS = ["10", "20", "50", "100"];

const ICON_BY_PLATFORM = {
  "-1": <span>Unknown</span>,
  "0": (
    <span>
      <Icon type="android" /> | <Icon type="apple" />
    </span>
  ),
  "1": (
    <span>
      <Icon type="android" />
    </span>
  ),
  "2": (
    <span>
      <Icon type="apple" />
    </span>
  ),
  "3": (
    <span>
      <Icon type="desktop" /> Device
    </span>
  ),
  "4": (
    <span>
      <Icon type="global" /> Web
    </span>
  )
};

class ListPage extends Component {
  state = {
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE
  };

  componentDidUpdate(prevProps) {
    // 本地分页时，重新搜索拿到新结果后回到第一页
    if (!this.props.pagination && prevProps.tasks !== this.props.tasks && this.state.current !== 1) {
      this.setState({ current: 1 });
    }
  }

  // 传了 pagination（服务端分页，如 native 列表）就以它为准，翻页交给 onPageChange 重新请求；
  // 没传（如 web 列表，接口一次返回全部）则在本地切页
  getPagination = tasks => {
    const { pagination, onPageChange } = this.props;
    const common = {
      showSizeChanger: true,
      pageSizeOptions: PAGE_SIZE_OPTIONS,
      showTotal: total => `共 ${total} 条`
    };
    if (pagination) {
      return {
        ...common,
        current: pagination.pageNum,
        pageSize: pagination.pageSize,
        total: pagination.total,
        onChange: onPageChange,
        onShowSizeChange: (current, pageSize) => onPageChange(1, pageSize)
      };
    }
    const { current, pageSize } = this.state;
    return {
      ...common,
      current,
      pageSize,
      total: tasks.length,
      onChange: this.handlePageChange,
      onShowSizeChange: this.handlePageChange
    };
  };

  handlePageChange = (current, pageSize) => {
    this.setState({ current, pageSize });
  };

  render() {
    const { filterConditions, tasks, updateFilterConditions, fetchTasks, fetchInitData, loading, type } = this.props;
    return (
      <div className={"listpage-container"}>
        <HeaderBar
          filterConditions={filterConditions}
          updateFilterConditions={updateFilterConditions}
          fetchTasks={fetchTasks}
          fetchInitData={fetchInitData}
          type={type}
        />
        <div className={"table-container"}>
            {
              (() => {
                if (type === "native") {
                  return this.renderNativeColumns(tasks, loading);
                } else if (type === "web") {
                  return this.renderWebColumns(tasks, loading);
                }
              })()
            }
        </div>
      </div>
    );
  }

  renderNativeColumns = (tasks, loading) => {
    return (
      <Table size="middle" dataSource={tasks} loading={loading} pagination={this.getPagination(tasks)} rowKey="taskId">
        <Column title="任务id" dataIndex="taskId" key="taskId" width="6%" />
        <Column title="诊断ID" dataIndex="diagnosisId" key="diagnosisId" width="12%" render={this.renderColumnDiagnosisId} />
        <Column title="AppId" dataIndex="appId" key="appId" width="9%"/>
        <Column title="AppVersion" dataIndex="appVersion" key="appVersion" width="8%"/>
        <Column title="设备序列号" dataIndex="deviceId" key="deviceId" width="12%" />
        <Column title="unionId" dataIndex="unionId" key="unionId" width="8%" />
        <Column title="用户描述" dataIndex="description" key="description" width="12%" render={this.renderColumnDescription} />
        <Column title="设备平台" dataIndex="platform" key="platform" width="8%" render={this.renderColumnPlatform} />
        <Column title="上传方式" dataIndex="uploadType" key="uploadType" width="6%" render={this.renderColumnUploadType} />
        <Column title="日志当天时间" dataIndex="logDate" key="logDate" width="9%" render={this.renderColumnLogDate} />
        <Column title="日志上报时间" dataIndex="addTime" key="addTime" width="11%" render={this.renderColumnAddTime} />
        <Column title="操作" dataIndex="action" width="8%" render={this.renderColumnAction} />
      </Table>
    );
  };

  renderWebColumns = (tasks, loading) => {
    return (
      <Table size="middle" dataSource={tasks} loading={loading} pagination={this.getPagination(tasks)} rowKey="taskId">
        <Column title="设备标识" dataIndex="deviceId" key="deviceId" width="30%" />
        <Column title="日志来源" dataIndex="webSource" key="webSource" width="15%" render={this.renderColumnWebSource} />
        <Column title="环境信息" dataIndex="environment" key="environment" width="15%" render={this.renderColumnEnvironment} />
        <Column title="日志当天时间" dataIndex="logDate" key="logDate" width="10%" render={this.renderColumnLogDate} />
        <Column title="日志上报时间" dataIndex="addTime" key="addTime" width="10%" render={this.renderColumnAddTime} />
        <Column title="操作" dataIndex="action" width="10%" render={this.renderColumnAction} />
      </Table>
    );
  };

  renderColumnPlatform = platform => {
    return ICON_BY_PLATFORM[platform] || ICON_BY_PLATFORM["-1"]
  };

  renderColumnUploadType = uploadType => {
    return <span>{getUploadTypeName(uploadType)}</span>
  };

  renderColumnDiagnosisId = diagnosisId => {
    if (!diagnosisId) {
      return <span>-</span>
    } else {
      return <span>{diagnosisId}</span>
    }
  };

  renderColumnDescription = description => {
    if (!description) {
      return <span>-</span>;
    }
    return (
      <Tooltip title={<span style={{ whiteSpace: "pre-wrap" }}>{description}</span>}>
        <div className="description-cell">{description}</div>
      </Tooltip>
    );
  };

  renderColumnWebSource = webSource => {
    if (webSource === null) {
      return <span>-</span>
    } else {
      return <span>{webSource}</span>
    }
  };

  renderColumnEnvironment = environment => {
    if (environment === null) {
      return <span>-</span>
    } else {
      return <span>{environment}</span>
    }
  };

  renderColumnLogDate = logDate => {
    return <div>{moment(logDate).format("YYYY-MM-DD")}</div>
  }

  renderColumnAddTime = addTime => {
    return <div>{moment(addTime).format("YYYY-MM-DD HH:mm:ss.SSS")}</div>;
  };

  renderColumnAction = (text, record, index) => {
    const {type} = this.props;
    if (type === "native") {
      return <Button onClick={this.toDetail(record.taskId)}>日志详情</Button>;
    } else {
      return <Button onClick={this.toDetail(record.tasks)}>日志详情</Button>;
    }
  };

  toDetail = tasks => () => {
    const {detailUrlPrefix} = this.props;
    this.props.history.push(`${detailUrlPrefix}?tasks=${tasks}`);
  };
}

export default ListPage;
